var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"bg-white sticky top-0 z-10"},[_c('sqr-page-header',{staticClass:"p-4",attrs:{"title":"Recherche"}}),_c('nav-tabs',{attrs:{"tabs":_vm.tabs}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }